import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { TypeActionApp } from "../app/actionApp";
import { actionLandingPageLogin } from "./actionLandingPage";
export var epicLandingPageLogin = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionApp.Init), switchMap(function () {
        return of(actionLandingPageLogin());
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/landing-page/epicLandingPageLogin.ts
// module id = 1980
// module chunks = 3